export const genericErrorMessage =
  "Das hat leider nicht geklappt. Bitte versuche es erneut oder kontaktiere den Support."
